import { useRef, useCallback } from 'react';
export function useFunctionalRef(defaultValue) {
    const refObject = useRef(defaultValue);
    const setRef = useCallback((value)=>{
        refObject.current = value;
    }, []);
    return [
        refObject,
        setRef
    ];
}
